import actionTypes from '../constants/action-types';

const setDesignAutomation = (config) => ({
  type: actionTypes.SET_DESIGN_AUTOMATION_CONFIG,
  payload: {
    config,
  },
});

export default setDesignAutomation;
